<template>
    <base_location_modal :tabs_advanced="tabs_add">
        <template v-slot:location_general_info="{ location, name }">
            <bolt_retail_general_tab :location="location"></bolt_retail_general_tab>
        </template>

    </base_location_modal>
</template>

<script>
import base_location_modal from "../../base/location_modal/base_location_modal";
import bolt_retail_general_tab from "./tabs/bolt_retail_general_tab";



export default {
    name: "bolt_retail_location_modal",
    components : {
        base_location_modal,
        bolt_retail_general_tab,

    },
    data () {
        return {
            tabs_add : [
                /* {
                     index : "bolt_work_hour",
                     title : this.__t('BOLT_WORK_HOUR'),
                 },
                 {
                     index : "bolt_labels",
                     title : this.__t('BOLT_LABELS'),
                 },*/
            ]
        }
    },
}
</script>

<style scoped>

</style>
